import { configureClient } from '@column/api';

import { API_URL } from '~/constants';
import { stepUpAwareFetch } from '~/lib/api/stepUpFetch';
import { useSessionStore } from '~/stores/Session';

configureClient({
  baseUrl: API_URL,
  fetch: stepUpAwareFetch,
  getSessionContext: () => {
    const state = useSessionStore.getState();
    return {
      platformId: state.currentPlatform?.id ?? state.currentUser?.defaultPlatformId ?? '',
      liveMode: !state.isSandbox,
    };
  },
});
